export default function PageHeader({ title, subtitle, action, testid }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-8" data-testid={testid}>
      <div>
        <h1 className="font-outfit font-bold text-3xl lg:text-4xl text-ink tracking-tight">{title}</h1>
        {subtitle && <p className="font-figtree text-ink-soft mt-1">{subtitle}</p>}
      </div>
      {action && <div>{action}</div>}
    </div>
  );
}
